export default "__VITE_ASSET__gTraAT3Q__"